import { ReactNode, useEffect, useRef } from 'react';
import { useSkipNav } from 'store/skip-nav';

export default function SkipNavLocation({ children }: { children: ReactNode }): JSX.Element {
  const ref = useRef<HTMLDivElement>(null);
  const { setRef } = useSkipNav();
  useEffect(() => {
    setRef(ref);
  }, [setRef]);
  return (
    <div ref={ref} tabIndex={0}>
      {children}
    </div>
  );
}
